export { MagnetManagerPage } from './MagnetManagerPage';
